<template lang="pug">
.user-team-plug
  EmptyImg.user-team-plug__img
  .user-team-plug__message
    .user-team-plug__title
      | {{title}}
    .user-team-plug__subtitle
      | {{subtitle}}


</template>

<script>
import EmptyImg from './EmptyImg';
export default {
  components: {
    EmptyImg
  },
  props: {
    title: {},
    subtitle: {}
  }
};
</script>
